import { CreditCard, Smartphone } from "lucide-react";

/**
 * Premium payment-methods strip — sits beside checkout / booking CTAs to
 * reassure visitors which payment routes are available. Stripe + Apple Pay
 * are live via Stripe Checkout (Apple Pay shows automatically on Safari /
 * iOS once the domain is verified in the Stripe Dashboard). PayPal is
 * STAGED — backend stub returns 501 until PAYPAL_CLIENT_ID is provided.
 */
export default function PaymentMethodsBadge({ compact = false }) {
  const methods = [
    { label: "Card", Icon: CreditCard, live: true, testid: "pay-stripe" },
    { label: "Apple Pay", Icon: Smartphone, live: true, testid: "pay-apple" },
    { label: "PayPal", Icon: null, live: false, testid: "pay-paypal" },
  ];

  return (
    <div
      data-testid="payment-methods-badge"
      className={`flex flex-wrap items-center gap-2 ${
        compact ? "" : "mt-4"
      }`}
    >
      <span className="text-[10px] uppercase tracking-[0.32em] font-bold text-zinc-500">
        Pay with
      </span>
      {methods.map(({ label, Icon, live, testid }) => (
        <span
          key={label}
          data-testid={testid}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] font-bold border ${
            live
              ? "border-amber-400/40 text-amber-300 bg-amber-400/5"
              : "border-white/10 text-zinc-500 italic"
          }`}
          title={live ? `${label} accepted` : `${label} — coming soon`}
        >
          {Icon && <Icon className="h-3 w-3" />}
          {label}
          {!live && <span className="not-italic">· soon</span>}
        </span>
      ))}
    </div>
  );
}
